import { HTMLAttributes } from 'react';

function IconInstagram(props: HTMLAttributes<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z'
        fill='white'
      />
      <rect width='48' height='48' rx='24' fill='url(#paint0_radial_58_4272)' />
      <rect width='48' height='48' rx='24' fill='url(#paint1_radial_58_4272)' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M24.0012 11.2002C20.5248 11.2002 20.0886 11.2154 18.7232 11.2775C17.3605 11.3399 16.4304 11.5557 15.6165 11.8722C14.7747 12.1991 14.0605 12.6365 13.349 13.3482C12.637 14.0597 12.1997 14.7738 11.8717 15.6154C11.5544 16.4296 11.3384 17.36 11.277 18.7221C11.216 20.0875 11.2 20.524 11.2 24.0003C11.2 27.4766 11.2154 27.9116 11.2773 29.2769C11.34 30.6396 11.5557 31.5697 11.872 32.3836C12.1992 33.2255 12.6365 33.9396 13.3482 34.6511C14.0594 35.3631 14.7736 35.8015 15.6149 36.1285C16.4293 36.445 17.3597 36.6607 18.7222 36.7231C20.0875 36.7853 20.5235 36.8005 23.9996 36.8005C27.4761 36.8005 27.9111 36.7853 29.2764 36.7231C30.6391 36.6607 31.5703 36.445 32.3847 36.1285C33.2263 35.8015 33.9394 35.3631 34.6506 34.6511C35.3626 33.9396 35.7999 33.2255 36.1279 32.3839C36.4426 31.5697 36.6586 30.6393 36.7226 29.2772C36.784 27.9118 36.8 27.4766 36.8 24.0003C36.8 20.524 36.784 20.0878 36.7226 18.7224C36.6586 17.3597 36.4426 16.4296 36.1279 15.6157C35.7999 14.7738 35.3626 14.0597 34.6506 13.3482C33.9386 12.6362 33.2266 12.1989 32.3839 11.8722C31.5679 11.5557 30.6372 11.3399 29.2745 11.2775C27.9092 11.2154 27.4745 11.2002 23.9972 11.2002H24.0012ZM23.5742 13.5069H23.5745L24.0011 13.507C27.4187 13.507 27.8238 13.5193 29.1734 13.5806C30.4214 13.6377 31.0988 13.8462 31.55 14.0214C32.1473 14.2534 32.5732 14.5308 33.0209 14.9788C33.4689 15.4268 33.7463 15.8535 33.9788 16.4508C34.154 16.9015 34.3628 17.5788 34.4196 18.8268C34.4809 20.1762 34.4943 20.5815 34.4943 23.9975C34.4943 27.4136 34.4809 27.8189 34.4196 29.1683C34.3625 30.4163 34.154 31.0936 33.9788 31.5443C33.7468 32.1416 33.4689 32.567 33.0209 33.0147C32.5729 33.4627 32.1476 33.74 31.55 33.972C31.0993 34.148 30.4214 34.356 29.1734 34.4131C27.8241 34.4744 27.4187 34.4878 24.0011 34.4878C20.5832 34.4878 20.1781 34.4744 18.8288 34.4131C17.5808 34.3555 16.9034 34.147 16.452 33.9718C15.8546 33.7398 15.4279 33.4624 14.9799 33.0144C14.5319 32.5664 14.2546 32.1408 14.0221 31.5432C13.8469 31.0925 13.6381 30.4152 13.5813 29.1672C13.5199 27.8178 13.5077 27.4125 13.5077 23.9943C13.5077 20.5762 13.5199 20.173 13.5813 18.8236C13.6383 17.5756 13.8469 16.8983 14.0221 16.4471C14.2541 15.8497 14.5319 15.423 14.9799 14.975C15.4279 14.527 15.8546 14.2497 16.452 14.0172C16.9032 13.8412 17.5808 13.6332 18.8288 13.5758C20.0096 13.5225 20.4672 13.5065 22.8528 13.5038V13.507C23.0757 13.5067 23.3155 13.5068 23.5742 13.5069ZM29.2977 17.1679C29.2977 16.3196 29.9857 15.6324 30.8337 15.6324V15.6319C31.6817 15.6319 32.3697 16.3199 32.3697 17.1679C32.3697 18.0159 31.6817 18.7039 30.8337 18.7039C29.9857 18.7039 29.2977 18.0159 29.2977 17.1679ZM24.0008 17.427C20.3708 17.4271 17.4277 20.3703 17.4277 24.0004C17.4277 27.6306 20.3709 30.5724 24.0011 30.5724C27.6313 30.5724 30.5734 27.6306 30.5734 24.0004C30.5734 20.3702 27.631 17.427 24.0008 17.427ZM28.2679 24.0001C28.2679 21.6436 26.3575 19.7334 24.0012 19.7334C21.6446 19.7334 19.7345 21.6436 19.7345 24.0001C19.7345 26.3564 21.6446 28.2668 24.0012 28.2668C26.3575 28.2668 28.2679 26.3564 28.2679 24.0001Z'
        fill='white'
      />
      <mask
        id='mask0_58_4272'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='48'
        height='48'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask0_58_4272)'></g>
      <defs>
        <radialGradient
          id='paint0_radial_58_4272'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(40.56 54.48) rotate(-115.776) scale(65.4568 97.3596)'
        >
          <stop offset='0.24392' stopColor='#FF1B90' />
          <stop offset='0.436673' stopColor='#F80261' />
          <stop offset='0.688476' stopColor='#ED00C0' />
          <stop offset='0.776787' stopColor='#C500E9' />
          <stop offset='0.893155' stopColor='#7017FF' />
        </radialGradient>
        <radialGradient
          id='paint1_radial_58_4272'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(17.4 46.344) rotate(-57.4396) scale(28.3618 29.5003)'
        >
          <stop stopColor='#FFD600' />
          <stop offset='0.484375' stopColor='#FF6930' />
          <stop offset='0.734375' stopColor='#FE3B36' />
          <stop offset='1' stopColor='#FE3B36' stopOpacity='0' />
        </radialGradient>
      </defs>
    </svg>
  );
}

export default IconInstagram;
